/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$navigation-toolbar-margin: 0 !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
}

.#{$prefix}navigation-toolbar-wrapper {
  margin: $navigation-toolbar-margin;
  position: relative;
  width: 100%;
  height: 72px;
  background-color: $navigation-toolbar-bg-color;
  z-index: 91; // z-index is higher than other navigation components to prevent hiding of overlay/flyout components behind other navigation components

  .#{$prefix}navigation-toolbar-inner {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: $content-max-width-desktop-l;
    margin: 0 auto 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: stretch;
    z-index: $mainNavigationZIndex;

    @include for-size(desktop-or-smaller) {
      max-width: $content-max-width-desktop;
    }
  }
}
